"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SortImg = _interopRequireDefault(require("../modules/SortImg.vue"));
var _creatTemplates = _interopRequireDefault(require("@/views/systemSetting/deliverGoods/freightSet/creatTemplates"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _systemSetting = require("@/api/systemSetting.js");
var _enum = require("../../enum");
var _common = require("../common");
var _api = require("../api");
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'goodsInfo',
  components: {
    SortImgVue: _SortImg.default,
    CreatTemplatesVue: _creatTemplates.default
  },
  props: {
    cloneForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      deliveryTimeEnum: _enum.deliveryTimeEnum,
      goodsTypeEnum: _enum.goodsTypeEnum,
      goodsStatusEnum: _enum.goodsStatusEnum,
      brandAuthEnum: _enum.brandAuthEnum,
      accountTypeEnum: _enum.accountTypeEnum,
      rechargeTypeEnum: _enum.rechargeTypeEnum,
      couponsGoodsAttrsEnum: _enum.couponsGoodsAttrsEnum,
      rules: _common.rules,
      props: _common.props,
      formConfig: _common.formConfig,
      comData: _common.comData,
      brandLoading: false,
      form: {
        productType: 1,
        sliderImages: [],
        productAttr: [],
        isQuota: null,
        quotaList: [{
          type: 1,
          checked: false,
          plan: null
        }, {
          type: 2,
          checked: false,
          plan: null
        }, {
          type: 3,
          checked: false,
          plan: null
        }, {
          type: 4,
          checked: false,
          plan: null
        }, {
          type: 5,
          checked: false,
          plan: null,
          time: []
        }],
        documentation: '',
        // 添加资质证明字段
        cardImage: '' // 卡片样式
      },
      userType: null,
      // 用户类型
      ID: this.$route.params.id,
      documentationFiles: [],
      // 添加资质证明文件列表
      currentPreviewUrl: '',
      // 当前预览的文件URL
      currentPreviewType: '' // 当前预览的文件类型
    };
  },
  mounted: function mounted() {
    // 获取用户类型
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
  },
  watch: {
    form: {
      handler: function handler(newVal, oldVal) {
        this.$emit('formChange', newVal);
        // console.log('form changed:', newVal, oldVal);
        // 在这里编写你需要的逻辑
      },
      deep: true
    },
    cloneForm: {
      handler: function handler(newForm) {
        var _this2 = this;
        this.form = _objectSpread(_objectSpread(_objectSpread({}, this.form), newForm), this.getSendTime(newForm.deliveryTime));
        // 处理资质证明文件
        if (newForm.documentation) {
          // 处理从字符串格式获取URLs
          var docUrls = newForm.documentation.split(',').filter(function (url) {
            return url.trim() !== '';
          });

          // 处理文件名数据
          var docNames = [];
          if (newForm.documentationName) {
            try {
              // 尝试解析JSON字符串
              docNames = JSON.parse(newForm.documentationName);
            } catch (e) {
              // 如果解析失败，尝试以逗号分隔的字符串解析
              docNames = newForm.documentationName.split(',');
            }
          }

          // 生成用于显示的文件列表
          this.documentationFiles = docUrls.map(function (url, index) {
            return {
              name: docNames && docNames[index] ? docNames[index] : _this2.getFileName(url),
              url: url
            };
          });
        }
        if (newForm !== null && newForm !== void 0 && newForm.supplierId) {
          setTimeout(function () {
            (0, _common.getSupplierList)(newForm === null || newForm === void 0 ? void 0 : newForm.supplierId, _this2.ID && Number(newForm === null || newForm === void 0 ? void 0 : newForm.productType) === 18 ? '' : newForm === null || newForm === void 0 ? void 0 : newForm.productType);
          }, 300);
        }
        ;
      }
    },
    'form.productType': {
      handler: function handler(productType) {
        if (productType && ([1, 2].includes(Number(productType)) || !this.ID && Number(productType) === 18)) {
          (0, _common.getSupplierList)('', productType);
        }
        ;
      },
      immediate: true,
      deep: true
    },
    'form.supplierId': {
      handler: function handler(supplierId) {
        var _this3 = this;
        if (!supplierId) {
          (0, _common.getSupplierList)('', this.ID && Number(this.form.productType) === 18 ? '' : this.form.productType || '');
        }
        ;
        this.brandLoading = true;
        (0, _common.getBrandList)('', supplierId);
        setTimeout(function () {
          _this3.brandLoading = false;
        }, 1500);
      },
      immediate: true,
      deep: true
    }
  },
  created: function created() {
    console.log(JSON.parse(_jsCookie.default.get('JavaInfo')).type, 'JavaInfo');
    console.log(this.goodsTypeEnum, 'goodsTypeEnum');
    if (JSON.parse(_jsCookie.default.get('JavaInfo')).type != 1) {
      // this.form.productType = 1;
      this.goodsTypeEnum = this.goodsTypeEnum.filter(function (item) {
        return item.value === 1;
      });
      console.log(this.goodsTypeEnum, 'goodsTypeEnum');
    }
  },
  methods: {
    throttle: _throttle.default,
    getBrandList: _common.getBrandList,
    getShippingList: _common.getShippingList,
    validate: _common.validate,
    remoteMethod: function remoteMethod(query) {
      // getSupplierList(query)
    },
    brandRemoteMethod: function brandRemoteMethod(query) {
      (0, _common.getBrandList)(query);
    },
    changeSliderImages: function changeSliderImages(data) {
      this.form.sliderImages = data;
    },
    brandVisibleChange: function brandVisibleChange(status) {
      if (status) return;
      (0, _common.getBrandList)('', this.form.supplierId);
    },
    // 搜索供应商
    handleSupplierSearch: function handleSupplierSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        (0, _common.getSupplierList)(data, _this4.ID && Number(_this4.form.productType) === 18 ? '' : _this4.form.productType || '');
      }, 300)();
    },
    supplierVisibleChange: function supplierVisibleChange(status) {
      //  if(status) return;
      //  getSupplierList()
    },
    /**
     * 获取商品信息spucode
     */
    getSpuCode: function () {
      var _getSpuCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _cateIdsObj$;
        var cateIdsObj, _this$form, storeName, brandIdObj, id, brandName, params, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              cateIdsObj = this.$refs['cateIdsRef'].getCheckedNodes();
              if (!(cateIdsObj && !(cateIdsObj !== null && cateIdsObj !== void 0 && cateIdsObj.length))) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _this$form = this.form, storeName = _this$form.storeName, brandIdObj = _this$form.brandIdObj, id = _this$form.id;
              if (brandIdObj) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              brandName = brandIdObj.brandName;
              params = {
                cateName: (_cateIdsObj$ = cateIdsObj[0]) === null || _cateIdsObj$ === void 0 ? void 0 : _cateIdsObj$.data.name,
                brandName: brandName,
                spuName: storeName
              };
              if (!(!params.spuName || id)) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _context.p = 3;
              _context.n = 4;
              return (0, _api.generateSPUCodeApi)(params);
            case 4:
              res = _context.v;
              if (res.code) {
                this.$set(this.form, 'spuCode', "".concat(res.code).concat(res.extraNum));
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              this.$message.error(_t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5]]);
      }));
      function getSpuCode() {
        return _getSpuCode.apply(this, arguments);
      }
      return getSpuCode;
    }(),
    /**
     * 上传图片
     */
    upLoadSliderImages: function upLoadSliderImages() {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        data.forEach(function (v) {
          if (!_this.validateSliderImage(v)) return;
          _this.form.sliderImages.push(v.sattDir);
        });
      }, 'duo', 'store', false, {
        maxSizeKB: 1000,
        maxSizeErrorMsg: '请上传大小≤1000KB的图片！'
      });
    },
    beforeSliderUpload: function beforeSliderUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var maxSize = 1000 * 1024;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (file.size > maxSize) {
        this.$message.error('请上传大小≤1000KB的图片！');
        return false;
      }
      return true;
    },
    validateSliderImage: function validateSliderImage(imageData) {
      var maxSize = 1000 * 1024;
      var sizeBytes = this.parseAttachmentSizeBytes(imageData);
      if (sizeBytes != null && sizeBytes > maxSize) {
        this.$message.error('请上传大小≤1000KB的图片！');
        return false;
      }
      return true;
    },
    parseAttachmentSizeBytes: function parseAttachmentSizeBytes(item) {
      if (!item) return null;
      var raw = item.attSize || item.att_size || item.fileSize || item.size;
      if (raw == null || raw === '') return null;
      if (typeof raw === 'number') {
        return raw > 1024 * 500 ? raw : raw * 1024;
      }
      var str = String(raw).trim();
      var kbMatch = str.match(/^([\d.]+)\s*KB$/i);
      if (kbMatch) return parseFloat(kbMatch[1]) * 1024;
      var mbMatch = str.match(/^([\d.]+)\s*MB$/i);
      if (mbMatch) return parseFloat(mbMatch[1]) * 1024 * 1024;
      var bMatch = str.match(/^([\d.]+)\s*B$/i);
      if (bMatch) return parseFloat(bMatch[1]);
      var num = parseFloat(str);
      if (!isNaN(num)) return num;
      return null;
    },
    // 处理本地轮播图上传
    handleSliderUpload: function () {
      var _handleSliderUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(options) {
        var file, formData, params, loading, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = options.file;
              if (this.beforeSliderUpload(file)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: this.ID || 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context2.p = 2;
              _context2.n = 3;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 3:
              res = _context2.v;
              loading.close();
              if (res && res.url) {
                this.form.sliderImages.push(res.url);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              loading.close();
              this.$message.error('上传失败：' + (_t2.message || '请重试'));
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function handleSliderUpload(_x) {
        return _handleSliderUpload.apply(this, arguments);
      }
      return handleSliderUpload;
    }(),
    // 卡片样式上传
    handleCardImageUpload: function handleCardImageUpload() {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        if (data && data.length > 0) {
          _this.form.cardImage = data[0].sattDir;
        }
      }, 'dan', 'store', false, {
        maxSizeKB: 500,
        maxSizeErrorMsg: '请上传大小≤500KB的图片！'
      });
    },
    // 删除卡片样式
    removeCardImage: function removeCardImage() {
      this.form.cardImage = '';
    },
    /**
     *  运费模板
     */
    addTem: function addTem() {
      var creatTemplatesVueRef = this.$refs.creatTemplatesVueRef;
      creatTemplatesVueRef.dialogVisible = true;
      creatTemplatesVueRef.getCityList();
    },
    addCate: function addCate() {
      this.$router.push({
        path: '/store/sort/ordinary'
      });
    },
    addShowCate: function addShowCate() {
      this.$router.push({
        path: '/store/sort/show'
      });
    },
    //回显发货时间
    getSendTime: function getSendTime(time) {
      if (this.ID && time) {
        var arr = this.deliveryTimeEnum.map(function (item) {
          return item.value;
        });
        var flag = !arr.includes(time);
        return {
          deliveryTime: flag ? 'other' : time,
          deliveryTimeOther: flag ? String(time) : ''
        };
      } else {
        return {};
      }
    },
    deliveryTimeChange: function deliveryTimeChange(value) {
      if (value !== 'other') {
        this.form.deliveryTimeOther = '';
      }
    },
    /**
     * 获取文件图标
     */
    getFileIcon: function getFileIcon(url) {
      var fileType = this.getFileType(url);
      var iconMap = {
        'image': 'el-icon-picture',
        'pdf': 'el-icon-document',
        'word': 'el-icon-document-checked',
        'excel': 'el-icon-s-grid',
        'powerpoint': 'el-icon-document',
        'text': 'el-icon-document',
        'unknown': 'el-icon-document'
      };
      return iconMap[fileType] || 'el-icon-document';
    },
    /**
     * 从URL中提取文件名
     */
    getFileName: function getFileName(url) {
      if (!url) return '';
      var parts = url.split('/');
      return parts[parts.length - 1];
    },
    /**
     * 获取文件类型
     */
    getFileType: function getFileType(url) {
      if (!url) return 'unknown';
      var fileName = this.getFileName(url).toLowerCase();
      var extension = fileName.split('.').pop();

      // 根据文件扩展名判断类型
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
        return 'image';
      } else if (extension === 'pdf') {
        return 'pdf';
      } else if (['doc', 'docx'].includes(extension)) {
        return 'word';
      } else if (['xls', 'xlsx', 'csv'].includes(extension)) {
        return 'excel';
      } else if (['ppt', 'pptx'].includes(extension)) {
        return 'powerpoint';
      } else if (['txt', 'log', 'md'].includes(extension)) {
        return 'text';
      }
      return 'unknown';
    },
    /**
     * 预览资质证明文件
     */
    previewDocument: function previewDocument(file) {
      var _this5 = this;
      this.currentPreviewUrl = file.url;
      this.currentPreviewType = this.getFileType(file.url);
      var previewUrl = '';

      // 根据文件类型选择预览方式
      if (this.currentPreviewType === 'image') {
        // 图片直接在新窗口打开
        previewUrl = file.url;
        window.open(previewUrl, '_blank');
      } else if (this.currentPreviewType === 'pdf') {
        // PDF文件 - 提供多种查看选项
        this.$confirm('请选择PDF预览方式', '选择预览方式', {
          confirmButtonText: '使用Google查看器',
          cancelButtonText: '直接打开',
          distinguishCancelAndClose: true,
          type: 'info'
        }).then(function () {
          // 使用Google Docs查看器
          previewUrl = _this5.getPdfViewerUrl(file.url, 'google');
          window.open(previewUrl, '_blank');
        }).catch(function (action) {
          if (action === 'cancel') {
            // 直接打开PDF (浏览器内置查看器)
            window.open(file.url, '_blank');
          }
        });
      } else if (['word', 'excel', 'powerpoint'].includes(this.currentPreviewType)) {
        // Office文档使用Office Online Viewer
        previewUrl = this.getOfficeViewerUrl(file.url, this.currentPreviewType);
        window.open(previewUrl, '_blank');
      } else {
        // 其他类型 - 提示下载
        this.$confirm('该文件类型可能无法直接预览，是否要下载查看？', '提示', {
          confirmButtonText: '下载',
          cancelButtonText: '取消',
          type: 'info'
        }).then(function () {
          _this5.downloadDocument(file);
        }).catch(function () {});
      }
    },
    /**
     * 下载资质证明文件
     */
    downloadDocument: function downloadDocument(file) {
      // 创建临时链接并触发下载
      var link = document.createElement('a');
      link.href = file.url;
      link.download = file.name || this.getFileName(file.url); // 优先使用原始文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    /**
     * 获取文件类型标签类型
     */
    getTagType: function getTagType(type) {
      switch (type) {
        case 'pdf':
          return 'danger';
        case 'word':
          return 'success';
        case 'excel':
          return 'info';
        case 'powerpoint':
          return 'warning';
        default:
          return 'info';
      }
    },
    /**
     * 获取文件类型名称
     */
    getFileTypeName: function getFileTypeName(type) {
      switch (type) {
        case 'pdf':
          return 'PDF文档';
        case 'word':
          return 'Word文档';
        case 'excel':
          return 'Excel文档';
        case 'powerpoint':
          return 'PPT文档';
        default:
          return '文档';
      }
    },
    /**
     * 获取PDF文档的在线预览URL
     */
    getPdfViewerUrl: function getPdfViewerUrl(url) {
      var viewer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'google';
      // 检查URL是否有效
      if (!url) return '';

      // 添加时间戳参数，避免缓存问题
      var timestampedUrl = url.includes('?') ? "".concat(url, "&timestamp=").concat(new Date().getTime()) : "".concat(url, "?timestamp=").concat(new Date().getTime());
      if (viewer === 'google') {
        // 使用Google Docs Viewer
        return "https://docs.google.com/viewer?url=".concat(encodeURIComponent(timestampedUrl), "&embedded=false");
      } else if (viewer === 'pdf.js') {
        // 使用PDF.js查看器
        return "https://mozilla.github.io/pdf.js/web/viewer.html?file=".concat(encodeURIComponent(timestampedUrl));
      } else {
        // 直接返回PDF URL，让浏览器自己处理
        return timestampedUrl;
      }
    },
    /**
     * 获取Office文档的在线预览URL
     */
    getOfficeViewerUrl: function getOfficeViewerUrl(url, type) {
      // 检查URL是否有效
      if (!url) return '';

      // 添加时间戳参数，避免缓存问题
      var timestampedUrl = url.includes('?') ? "".concat(url, "&timestamp=").concat(new Date().getTime()) : "".concat(url, "?timestamp=").concat(new Date().getTime());

      // 使用Microsoft Office Online Viewer
      var encodedUrl = encodeURIComponent(timestampedUrl);

      // 基础参数 - 使用view.aspx而非embed.aspx，适合新窗口
      var params = {
        src: encodedUrl
      };

      // 构建查询字符串
      var queryString = Object.entries(params).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return "".concat(key, "=").concat(value);
      }).join('&');

      // 返回完整的URL - 使用view而非embed
      return "https://view.officeapps.live.com/op/view.aspx?".concat(queryString);
    }
  }
};